

import { useState, useRef, Fragment } from "react";
import Config from "../../Config";
import InputText from "../../helpers/InputText";
import AppContext from "../../AppContext";

import directory from "../../directory.png"
import arrow_back from "../../arrow_back.png"
import CloudNew from "./CloudNew";
import MenuTable from "../../helpers/MenuTable";
import CloudEdit from "./CloudEdit";


import ico_pdf from "../../ico_pdf.png"
import ico_doc from "../../ico_doc.png"
import ico_zip from "../../ico_zip.png"
import ico_pp  from "../../ico_pp.png"
import MediaBrowser from "../../helpers/MediaBrowser";
import InputUploader from "../../helpers/InputUploader";
import PackToZip from "./PackToZip";
import InputDate from "../../helpers/InputDate";

function Cloud(props)
{

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);

    const [path, setPath] = useState([]);

    const [filter, setFilter] = useState(null);
    const [filterParam, setFilterParam] = useState({
        fraza: '',
        data_od: '',
        data_do: '',
        typ: '',
        typ_id: '', 
        limit: 50,
        page: 1,
        pages: 1,
        show: false,
    });
    const [tab, setTab] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);

    const tabRef = useRef(0); //do druku


 
    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    const getTab = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.master + '/rest_v1,cloud', {
            method: 'POST', 
            body: JSON.stringify(filterParam), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                    }else    
                    {
                        setTab(res.result);            
                        if(res.pages != undefined )setFilterParam( {...filterParam,   ['pages']: res.pages  } );             


                        var newSelector = [];

                        for(var k=0; k<res.result.length; k++)
                        {
                            var item = res.result[k];
                            if(item.c != undefined && item.c.length > 2)
                            {
                                newSelector.push({
                                    id: item.typ_id,
                                    title: item.name,                             
                                    crypt: item.c,
                                    selected: 0,
                                }); 
                            }
                        }
                      
                        setSelectedRow(newSelector);


                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }




    const valChangeListener = (filedName, val, correct, msg) => {

        //console.log("valChangeListener: " + filedName + " " + val + ", correct: " + correct + ", msg: " + msg);

        setFilterParam( {...filterParam, [filedName]:val,  [filedName+"_valid"]:correct } );
        
        if(   (val.length == 0 || val.length > 2 || msg =='combo')  && filterParam[filedName] != val )
            {
                    var defTimeOut = 1000;
                    if(msg == 'combo') defTimeOut = 10;
                    clearTimeout(AppContext.timeoutId);
                    AppContext.timeoutId = setTimeout( () => {
                        setTab(null); 
                    } , defTimeOut );
            }
    }


    const goNextNew = () => {
        console.log("goNext");    
        setTab(null);    
    }

    
    const filterView = () => {
        setFilterParam(  {...filterParam, ["show"]:!filterParam.show } );
    }

    const filterClear = () => {
        setFilterParam({
            fraza: '',  
            data_od: '',
            data_do: '',
            typ: '',
            typ_id: '' ,
            limit: 50,
            page: 1,
            show: true
        });


        setPath([]);

        setTab(null);
    }

    const filterApprove = () => {   
        setTab(null)     
    }

    const onChangePagger = (x_limit, x_page) => {

        setFilterParam(  {...filterParam, ["limit"]:x_limit, ["page"]:x_page} );
        setTab(null);
    }



    const onSuccess = () => {

        setView({
            v:'list',
            id: -1,
        });

        getTab();
    }

    const onClose = () => {

        setView({
            v:'list',
            id: -1,
        });

       
    }

    const showZip = () => {

        setView({
            v:'zip',
            id: -1,
        });

    }


    const goTop = (e)  => {

       // console.log("path", path);

        var last = path[ path.length - 2];

        if(last == null) 
        {
           // console.log("XNull...");
            setPath([]);
            setFilterParam( { ...filterParam, ["typ"]:"", ["typ_id"]:"-1"  });           
            setTab(null);
            return;
        }


        var newPushList = new Array();

        for(var k=0; k<path.length-1; k++)
        {
            newPushList.push( path[k] );
        }

        setPath(newPushList);

        setFilterParam( { ...filterParam, ["typ"]:last.typ, ["typ_id"]:last.typ_id  });           
        setTab(null);

      //  console.log("Last", last);

    }

    const goDown = (e)  => {

         // atr-typ={row.typ} atr-typId={row.typ_id}  atr-name={row.name}
         var typ    = e.currentTarget.getAttribute("atr-typ"); 
         var typId  = e.currentTarget.getAttribute("atr-typId"); 
         var name   = e.currentTarget.getAttribute("atr-name"); 

         var crypt   = e.currentTarget.getAttribute("atr-crypt"); 


         if(crypt != null && crypt.length > 3) //to plik..
         {
            return; 
         }

        
         var tmp = path;
         tmp.push({
            'typ'   :typ,
            'typ_id':typId,
            'name'  :name,
         });

         setPath(tmp);
         setFilterParam( { ...filterParam, ["typ"]:typ, ["typ_id"]:typId  });           
         setTab(null);

       
    }



    const goChange = (e)=> {

        var id = e.target.getAttribute("id");     
        var name = e.target.getAttribute("name");   

        setView({
            v:'change',
            id: id,
        });
    }


    
    const goDelete = (e) => {

        var id = e.target.getAttribute("id");     
        var name = e.target.getAttribute("name");     

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć '" + name + "'?", "yesno", (option)=>{
          
                    
                        if(option == "yes") goDeleteApproved(id);
                    
        } );
    }

    const goDeleteApproved = (id) => {
 
    

        props.mainView.setProgress(-2);

        var req = {
            id: id
        }

        fetch( Config.master + '/rest_v1,cloud_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Pozycja została usunięta", "ok" , null);                        
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }






    const goDeleteF = (e) => {

        var crypt = e.target.getAttribute("crypt");     
        var name = e.target.getAttribute("name");     

        props.mainView.showDialog("Potwierdź", "Czy na pewno chcesz usunąć '" + name + "'?", "yesno", (option)=>{
          
                    
                        if(option == "yes") goDeleteFApproved(crypt);
                    
        } );
    }

    const goDeleteFApproved = (crypt) => {
 
    

        props.mainView.setProgress(-2);

        var req = {
            crypt: crypt
        }

        fetch( Config.master + '/rest_v1,cloud_file_del', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => {             
                    
                    props.mainView.setProgress(-1);

                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: ext:" + JSON.stringify(res) , "ok" , null);  
                    }else
                    if(res.status != undefined && res.status == "OK")
                    {
                        props.mainView.showDialog( "Sukces",  "Katalog został usunięty", "ok" , null);                        
                        setTab(null);
                    }else
                    {
                        props.mainView.showDialog( "Error", "Something is wrong: " + JSON.stringify(res) , "ok" , null);  
                    }
                   
         } )
         .catch(err => {   
                    props.mainView.setProgress(-1);       
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
         });
                   

         return false;

    }



    const completeUpload = (fileName, crypt) => {

        console.log("completeUpload: " + fileName + " " + crypt);
      /* 
         tmpFiles.push({
            fileName: fileName,
            crypt: crypt
        });
 
        setRow(  {...row, ["files"]: tmpFiles  } );
        */
       getTab();
    }




//-------------------------------------------------------
//-------------------------------------------------------
//MASS
const changeSelected = (e) => {

    var id    = e.target.getAttribute('atr-id');   
    var selected = 0;

    //console.log("XXXX", id);
   // console.log("YYYY", selectedRow);

    if(e.target.checked) selected = 1;

    for(var k=0; k<selectedRow.length; k++)
    {
        if(selectedRow[k].id == id)  
        {
          //  console.log("selected..", selected);
            selectedRow[k].selected = selected;
        }
    }

    setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) );    
}

const changeSelectedAll = (e) => {

    var s = selectedRow[0].selected;
    if(s == 1) {  s = 0; } else s = 1;

    for(var k=0; k<selectedRow.length; k++)
        {
          selectedRow[k].selected = s;
        }
    
        setSelectedRow(  JSON.parse(JSON.stringify(selectedRow) ) ); 

}


//-------------------------------------------------------
//-------------------------------------------------------





    if(tab == null)
        {
            setTab([]);
            getTab();
    
            return <div>
                ...
            </div>
        }
    
    
        if(refreshView != props.userData.refreshView)
        {         
            setRefreshView( props.userData.refreshView);
            setTab(null);
        }
    
    


    var pathInfo = "eLizak://";
    

    for(var k=0; k < path.length; k++ )
    {
        pathInfo = pathInfo + "/" + path[k].name;
    }



    var dlg = null;

    if(view.v == "change")
    {
        var inx = -1;
        for(var k=0; k < tab.length; k++)
        {
            if(tab[k].typ_id == view.id) {
                inx = k; break;
            }
        }

        if(inx < 0 )
        {
            dlg =  <div>
                ....
             </div>
        }


        var gr = new Array();

        for( var k=0; k <  tab[inx].grupy.length; k++ )
        {
            gr[k] = tab[inx].grupy[k].id;
        }



        var def = {          
            typ:  tab[inx].typ,  
            typ_id:  tab[inx].typ_id,  
            nazwa:  tab[inx].name,  
            grupy: gr,        
            rodzice:  tab[inx].r,
            rodzice_valid: true,
            pracownicy:  tab[inx].p,
            pracownicy_valid: true,
        };



       
          dlg = <CloudEdit userData={props.userData} mainView={props.mainView}  def={def}  onSuccess={onSuccess}  />
        
    }


    if(view.v == "zip" )
        {
            var ids = new Array();           
                    
            for(var k=0; k<selectedRow.length; k++)
                {                  
                        if( selectedRow[k].selected == 1)
                        {                            
                            ids.push({
                                id: selectedRow[k].id,
                                title: selectedRow[k].title
                            });
                               
                        }
                }

               dlg = <PackToZip userData={props.userData} mainView={props.mainView} tab={ids}   onClose={onClose} onSuccess={onSuccess}   />
        }



    var zaznaczonych = 0;
    var arrSelected = new Array();    
 
    for(var s=0; s<selectedRow.length; s++)
    {
        if(selectedRow[s].selected == 1) 
        {
            zaznaczonych ++;
            arrSelected.push( selectedRow[s] );                   
        }
    }


    return (
                <div className="view_content">
                 

                                {
                                    filterParam.show == false  &&
                                    <div className="  goright link_color" onClick={filterView}>
                                        pokaż filtry
                                    </div>
                                } 


                                {
                                    filterParam.show == true  &&
                                    <div className="table_filter">
                                    
                                            <div className="filter_controll">   
                                                <label>Fraza: </label>                             
                                                <InputText   userData={props.userData} value={filterParam.fraza}   valChange={valChangeListener} goNext={goNextNew} name="fraza" placeholder={"Fraza: "}   />
                                            </div>  


                                            <div className="filter_controll filter_merge">   
                                                        <label>Data utworzenia (od dnia / do dnia): </label>      <br/>                       
                                                        <InputDate   userData={props.userData} value={filterParam.data_od}   valChange={valChangeListener} goNext={goNextNew} name="data_od" placeholder={"Od dnia: "}   />                                                                  
                                                        <InputDate   userData={props.userData} value={filterParam.data_do}   valChange={valChangeListener} goNext={goNextNew} name="data_do" placeholder={"Do dnia: "}   />
                                            </div> 

                                            <div className="filter_btn">
                                                <span className="link_color" onClick={filterView}>&nbsp;ukryj filtry&nbsp;</span> 
                                                <span className="btn" onClick={filterApprove} >filtruj</span>&nbsp;&nbsp;<span className="btn" onClick={filterClear} >wyczyść</span>
                                            </div>

                                    </div>
                                }  


                                    <div className="bg_center">
                                            <div className="path_view"> <img src={arrow_back} className="path_back" onClick={goTop} /> {pathInfo}</div>
                                    </div>


                                    <div className="table_widget">

                                            {
                                                path.length == 0 &&
                                                <Fragment>
                                                        <CloudNew userData={props.userData} mainView={props.mainView} onSuccess={onSuccess} />
                                                </Fragment>
                                            }


                                            {
                                                filterParam.typ == 'p_chmura' &&
                                                <Fragment>
                                                     <InputUploader   userData={props.userData}  typ="p_chmura" typId={ filterParam.typ_id  } remove="0" completeUpload={completeUpload} title={ "dodaj pliki (+)" } className="btn" max_files="10" ext="*/*" />                                                               
                                                </Fragment>
                                            }

                                         

                                    </div>

                                    {
                                        zaznaczonych > 0 &&
                                        <div className="table_mass">  
                                            <div className="title_mass">Operacje masowe (zaznaczono: {zaznaczonych}) </div>          
                                            &nbsp;
                                            <span className="btn" onClick={showZip}>utwórz i pobierz .zip</span>                   
                                        </div>
                                    }            
                                    

                                    <div className="bg_center">

                                                <table className="table" ref={tabRef}>
                                                        <thead>
                                                            <tr className="header">
                                                                <td className="link_normal td_left" onClick={changeSelectedAll}>&nbsp;Z&nbsp;</td>                                                                       
                                                                <td> &nbsp; </td>                                                          
                                                                <td>Nazwa</td>                                                          
                                                                <td>Uprawnienia</td>                                                          
                                                                <td>Rozmiar</td>                                                           
                                                                <td className="td_right">Data utworzenia</td>                                             
                                                                <td className="td_option"> </td>                                                            
                                                            </tr>
                                                        </thead>
                                                        <tbody>

                                                        {
                                                            tab.map( (row, ix) => {

                                                                var rowStyle = " row ";
                                                                if(ix % 2 == 0 )rowStyle = " row2 ";

                                                                var isChecked = "";

                                                                for(var s=0; s<selectedRow.length; s++)
                                                                    {
                                                                        if( selectedRow[s].id == row.typ_id &&  selectedRow[s].selected == 1) isChecked = "checked";
                                                                    }
        

                                                                 return <tr className={rowStyle}  key={ix} >            

                                                                    <td className="gocenter">
                                                                         {
                                                                            row.c != undefined && row.c.length > 2 &&
                                                                            <input type="checkbox" atr-id={row.typ_id} onChange={changeSelected} checked={isChecked} />
                                                                         }                                                                         
                                                                    </td>

                                                                    <td className="gocenter" atr-typ={row.typ} atr-typId={row.typ_id}  atr-name={row.name}  atr-crypt={row.c} onClick={goDown}  >

                                                                       

                                                                        {
                                                                            row.b64.length > 10 &&
                                                                            <MediaBrowser userData={props.userData} mainView={props.mainView}  className="ico_directory" review={row.b64} typ={"none"} typId={-1}  crypt={row.c}  />
                                                                        }

                                                                        {
                                                                            row.b64.length <= 10 && row.t.length <= 2 &&
                                                                            <img src={directory}  className="ico_directory"/>
                                                                        }

                                                                        {
                                                                            row.b64.length <= 10 && row.t == 'pdf' &&
                                                                            <MediaBrowser userData={props.userData} mainView={props.mainView}  className="ico_directory" review={ico_pdf} typ={"none"} typId={-1}  crypt={row.c}  />
                                                                        }

                                                                        {
                                                                            row.b64.length <= 10 && row.t == 'doc' &&
                                                                            <MediaBrowser userData={props.userData} mainView={props.mainView}  className="ico_directory" review={ico_doc} typ={"none"} typId={-1}  crypt={row.c}  />
                                                                        }

                                                                        {
                                                                            row.b64.length <= 10 && row.t == 'docx' &&
                                                                            <MediaBrowser userData={props.userData} mainView={props.mainView}  className="ico_directory" review={ico_doc} typ={"none"} typId={-1}  crypt={row.c}  />
                                                                        }

                                                                        {
                                                                            row.b64.length <= 10 && row.t == 'zip' &&
                                                                            <MediaBrowser userData={props.userData} mainView={props.mainView}  className="ico_directory" review={ico_zip} typ={"none"} typId={-1}  crypt={row.c}  />
                                                                        }
                                                                      
                                                                    </td>
                                                                    <td>
                                                                    {row.name}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            row.sys == 1 &&
                                                                            <span>&nbsp;Folder systemowy&nbsp;</span>
                                                                        }

                                                                        {
                                                                            row.r == 1 &&
                                                                            <span>&nbsp;Rodzice&nbsp;</span> 
                                                                        }

                                                                        {
                                                                            row.p == 1 &&
                                                                            <span>&nbsp;Pracownicy&nbsp;</span> 
                                                                        }

                                                                        {
                                                                            row.grupy.map( (gr,gInx) => {
                                                                                    return <span>
                                                                                       &nbsp;  {gr.nazwa} &nbsp;
                                                                                    </span>
                                                                            } )
                                                                        }

                                                                    </td>
                                                                    <td className="goright" atr-typ={row.typ} atr-typId={row.typ_id}  atr-name={row.name}  atr-crypt={row.c} onClick={goDown}>{row.size}</td>
                                                                    <td className="gocenter" atr-typ={row.typ} atr-typId={row.typ_id}  atr-name={row.name} atr-crypt={row.c}  onClick={goDown}>{row.created_at}</td>
                                                                    <MenuTable>
                                                                        <ul>

                                                                            {
                                                                                row.c.length < 2 &&
                                                                                <li  atr-typ={row.typ} atr-typId={row.typ_id}  atr-name={row.name} atr-crypt={row.c}  onClick={goDown} >pokaż zawartość</li>                                                                            
                                                                            }
                                                                                                                                                                                                                                 
                                                                             
                                                                            {
                                                                                row.typ == "p_chmura" &&
                                                                                <li onClick={goDelete} name={row.name} id={row.typ_id} >usuń</li>
                                                                            }   

                                                                            {
                                                                                row.typ == "p_chmura" &&
                                                                                <li onClick={goChange} name={row.name} id={row.typ_id} >zmień</li>
                                                                            }   

                                                                            {
                                                                                row.typ == "plg_pliki" && row.d == 0 &&
                                                                                <li onClick={goDeleteF} name={row.name} crypt={row.c} >usuń</li>
                                                                            }

                                                                            
                                                                        </ul>
                                                                    </MenuTable>
                                                                 </tr>

                                                            } )
                                                        }

                                                        </tbody>
                                                </table>    
                                        
                                    </div> 


                                    {dlg}
            </div>

    )
}


export default Cloud;